import {
  useQuery,
  type QueryKey,
  type UseQueryOptions,
} from '@tanstack/react-query';

import { API_QUERY_DEFAULTS } from './defaults';

type UseApiQueryOptions<TData, TError = Error> = Omit<
  UseQueryOptions<TData, TError, TData, QueryKey>,
  'queryKey' | 'queryFn'
> & {
  queryKey: QueryKey;
  queryFn: () => Promise<TData>;
};

export function useApiQuery<TData, TError = Error>(
  options: UseApiQueryOptions<TData, TError>,
) {
  const { queryKey, queryFn, ...rest } = options;
  return useQuery({
    ...API_QUERY_DEFAULTS,
    queryKey,
    queryFn,
    ...rest,
  });
}
